import styled from 'styled-components';

export const GoalsTabContainer = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: ${(props) =>
    props.theme
      .goalsTableContainerBackground}; // Use props for theme access in v6
  @media (max-width: 768px) {
    width: auto;
  }
`;

export const GoalsEmptyContainer = styled.div`
  width: 50%;
  height: 67.5%;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.goalsRowDivider}; // Use props for theme access in v6
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 80px;
  padding-right: 80px;
  background: ${(props) =>
    props.theme.goalsTextareaBackground}; // Use props for theme access in v6
  @media (max-width: 768px) {
    width: 100%;
    button {
      width: 70%;
    }
    p {
      text-align: center;
    }
  }
`;

export const GoalsEmptyImage = styled.img`
  width: 200px;
  height: 200px;
  margin-bottom: 25px;
`;

export const GoalsEmptyTitle = styled.h1`
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
`;

export const GoalsEmptyText = styled.p`
  margin-bottom: 10px;
`;

export const GoalsAddButtonMobile = styled.div`
  position: fixed;
  background: #5b5fc7;
  border-radius: 100px;
  padding: 8px;
  bottom: 20px;
  right: 20px;
  width: 120px;
  height: 48px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  gap: 2px;
  z-index: 1;
  cursor: pointer;
  &:active {
    background: #3f4299;
  }
`;

export const GoalsMobilePopupTarget = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 9999;
`;
